export { EventDetailStackNavigator } from "./components/EventDetailStackNavigator";
